import { schema } from 'normalizr';

import { processDismissablePrompt } from '../strategies/dismissablePrompt';

const dismissablePromptByTypeSchema = new schema.Entity(
  'dismissablePromptsByType',
  {},
  { idAttribute: 'promptKey', processStrategy: processDismissablePrompt }
);

export const dismissablePromptsByTypeSchema = [dismissablePromptByTypeSchema];
export type DismissablePromptsByTypeSchema = typeof dismissablePromptsByTypeSchema;
